// extracted by mini-css-extract-plugin
export default {"CategoryColorPicker":"CategoryColorPicker_CategoryColorPicker__0k6sf","ColorPickerWrapper":"CategoryColorPicker_ColorPickerWrapper__jISyj"};